import { useNavigate, useLocation } from "react-router-dom";
import { 
  Home,
  Target,
  Users,
  ClipboardList,
  User,
  FileText,
  Bell,
  BarChart3,
  Menu
} from "lucide-react";
import { isAdvisor } from "../utils/auth";

export default function MobileBottomNav({ onMenuClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const canManage = isAdvisor();

  const navItems = [
    { 
      icon: Home, 
      label: "Home", 
      path: "/advisor/dashboard",
      active: currentPath === "/advisor/dashboard"
    },
    { 
      icon: Target, 
      label: "Leads", 
      path: "/advisor/leads",
      active: currentPath === "/advisor/leads"
    },
    { 
      icon: FileText, 
      label: "Map Policy", 
      path: "/advisor/map-policy",
      active: currentPath === "/advisor/map-policy",
      highlight: true
    },
    { 
      icon: Users, 
      label: "Clients", 
      path: "/advisor/clients",
      active: currentPath === "/advisor/clients" || currentPath.startsWith("/advisor/clients/")
    },
    { 
      icon: Menu, 
      label: "Menu", 
      isMenu: true,
      active: false
    }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-[#C9D4E6] z-40 pb-8">
      <div className="flex items-center justify-around px-2 py-1">
        {navItems.map((item, index) => (
          <button
            key={item.path || index}
            onClick={() => item.isMenu ? onMenuClick?.() : navigate(item.path)}
            className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all min-w-[60px] ${
              item.active 
                ? 'text-[#A87608]' 
                : 'text-[#3A4557] hover:text-[#2E3B57]'
            } ${item.highlight ? 'relative' : ''}`}
          >
            {item.highlight ? (
              <div className="absolute -top-4 bg-gradient-to-r from-[#D4A017] to-[#D9A82C] p-3 rounded-full shadow-lg shadow-[#D4A017]/20">
                <item.icon className="h-5 w-5 text-[#0D1A3A]" />
              </div>
            ) : (
              <item.icon className={`h-5 w-5 ${item.active ? 'scale-110' : ''} transition-transform`} />
            )}
            <span className={`text-[10px] mt-1 font-medium ${item.highlight ? 'mt-5' : ''}`}>
              {item.label}
            </span>
            {item.active && !item.highlight && (
              <div className="absolute bottom-1 w-1 h-1 bg-[#D4A017] rounded-full" />
            )}
          </button>
        ))}
      </div>
    </nav>
  );
}
